module.exports = __webpack_public_path__ + "media/images/target-blank-e23b8e2bc2f163ce389a5f698bae2ae1.svg";